import api from "./api";

function redirectPreviusUri(redirectUri) {
    window.location = redirectUri;
}
async function GetAuthentication(
    apiUrl: string,
    access_token: string,
    client_id: string,
    redirect_uri: string
) {
    try {
        api.get(apiUrl, {
            headers: {
                Authorization: `Bearer ${access_token}`,
                "Content-Type":
                    "application/x-www-form-urlencoded;charset=UTF-8",
                client_id: `${client_id}`,
            },
        })
            .then((res) => {
                const userResponse = res.data.userAccounts[0];
                localStorage.setItem("user", JSON.stringify(userResponse));
            })
            .then(() => redirectPreviusUri(redirect_uri));
    } catch (error) {
        console.log(error);
    }
}

export default GetAuthentication;
